module.exports = __webpack_public_path__ + "static/media/icon-pdf-label.7285e11c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-pdf-label.svg
// module id = 467
// module chunks = 0